// import {inputService} from "../inputService";
// import {isDesktopGame, process} from "../../app";
// import {gameEvents} from "../../gameLogic/gameEvents";
// import {slotParams} from "../../slotParams";
// import {getScreenOrientation, screenOrientationTypes} from "../../screenOrientation";
import * as PIXI from 'pixi.js';
import { BaseSpine } from '../../core/pixi/pixiBaseSpine';

const commonMethods = {
  activateInputMode() {
    this.interactive = true;
    this.buttonMode = true;
  },
  deactivateInputMode() {
    this.interactive = false;
    this.buttonMode = false;
  },
  enable() {
    if (!this.interactive || this.enabled) return;
    this.enabled = true;
    this.buttonMode = true;
    this.emit('enabled');
  },
  disable() {
    if (!this.interactive || !this.enabled) return;
    this.enabled = false;
    this.buttonMode = false;
    this.emit('disabled');
  },
  isEnabled() {
    return this.interactive && this.enabled;
  },
  addOnDownHandler(handler, context) {
    if (process.env.BUILD_TYPE === 'testView') return;
    const eventType =
      isDesktopGame() || process.env.BUILD_TYPE.includes('test') ? 'pointerdown' : 'touchstart';
    this.on(eventType, (event) => {
      if (isValidMouseButtonInput(event)) {
        return handler.call(context, event);
      }
    });
  },
  addOnUpHandler(handler, context) {
    if (process.env.BUILD_TYPE === 'testView') return;
    const eventType =
      isDesktopGame() || process.env.BUILD_TYPE.includes('test') ? 'pointerup' : 'touchend';
    this.on(eventType, (event) => {
      if (isValidMouseButtonInput(event)) {
        return handler.call(context, event);
      }
    });
  },
  addHoverHandler(handler, context) {
    if (process.env.BUILD_TYPE === 'testView') return;
    const wrap = (event) => {
      event.currentTarget._hovered = true;
      handler.call(context, event);
    };
    this.on('mouseover', wrap);
  },
  addUnHoverHandler(handler, context) {
    if (process.env.BUILD_TYPE === 'testView') return;
    const wrap = (event) => {
      if (event.currentTarget._hovered) {
        event.currentTarget._hovered = false;
        handler.call(context, event);
      }
    };
    this.on('mouseout', wrap);
  },
  getLeft() {
    return this.x + this.getLocalBounds().x;
  },
  getRight() {
    return this.x + this.getLocalBounds().right;
  },
  getTop() {
    return this.y + this.getLocalBounds().y;
  },
  getBottom() {
    return this.y + this.getLocalBounds().y;
  },
  hide() {
    this.visible = false;
  },
  show() {
    this.visible = true;
  },
  setScale(values) {
    if (typeof values === 'number') this.scale.set(values);
    else if (typeof values === 'object') {
      this.scale.set(values.x, values.y);
    }
  },
  toFront() {
    if (!this.parent) return;
    const lastIndex = this.parent.children.length - 1;
    this.parent.setChildIndex(this, lastIndex);
  },
  toBack() {
    if (!this.parent) return;
    this.parent.setChildIndex(this, 0);
  },
  destroy(...args) {
    this.constructor.prototype.destroy.call(this, ...args); //super y stex chi ashxatum dra hamar ays dzevov areci
    this.__listeners.forEach((u) => u());
    this.__listeners.length = 0;
  },
  getLocalPositionOfTarget(target) {
    this.parent.updateTransform();
    return [
      (target.worldTransform.tx - this.parent.worldTransform.tx) / this.parent.worldTransform.a,
      (target.worldTransform.ty - this.parent.worldTransform.ty) / this.parent.worldTransform.d,
    ];
  },
};

export function construct(options) {
  if (options?.parent) {
    if (options.slotName && options.parent instanceof BaseSpine) {
      options.parent.addChildToSlot(options.slotName, this);
    } else options.parent.addChild(this);
  }
  this.elementId = options.elementId;
  for (const method in commonMethods) {
    this[method] = commonMethods[method].bind(this);
  }
  if (options.styles) this.applyStyles(options.styles);
  if (options.setRef) options.setRef(this);
  if (options.children) {
    options.children.forEach((ch) => ch && this.addChild(ch));
  }
  this.__listeners = [];
}

// const commonSetterGetters = {
//     enabled:{
//         setDefault(){
//             this._enabled = false;
//         },
//         setter(v){
//             if(!this.interactive || this._enabled === v)return;
//             this._enabled = v;
//             this.buttonMode = v;
//             this.emit(v ? 'enabled' : 'disabled');
//         },
//         getter(){
//             return this.interactive && this._enabled;
//         }
//     }
// };
const MOUSE_LEFT_BUTTON = 0;
export function isValidMouseButtonInput(event) {
  return event.data.pointerType !== 'mouse' || event.data.button === MOUSE_LEFT_BUTTON;
}
